const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const scriptId = 'google-recaptcha-v3';

let scriptPromise;

const waitForRecaptcha = () =>
  new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      if (typeof window.grecaptcha.execute !== 'function') {
        reject(new Error('Google reCAPTCHA is unavailable.'));
        return;
      }

      resolve(window.grecaptcha);
    });
  });

const loadRecaptcha = () => {
  if (!siteKey) {
    return Promise.reject(
      new Error('Google reCAPTCHA is not configured for this website.'),
    );
  }

  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Google reCAPTCHA requires a browser.'));
  }

  if (window.grecaptcha) {
    return waitForRecaptcha();
  }

  if (scriptPromise) {
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(scriptId);
    const script = existingScript || document.createElement('script');

    const handleLoad = () => {
      waitForRecaptcha().then(resolve).catch(reject);
    };
    const handleError = () => {
      scriptPromise = undefined;
      reject(new Error('Google reCAPTCHA could not be loaded.'));
    };

    script.addEventListener('load', handleLoad, { once: true });
    script.addEventListener('error', handleError, { once: true });

    if (!existingScript) {
      script.id = scriptId;
      script.async = true;
      script.defer = true;
      script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(
        siteKey,
      )}&trustedtypes=true`;
      document.head.appendChild(script);
    }
  });

  return scriptPromise;
};

export const getRecaptchaToken = async (action) => {
  const recaptcha = await loadRecaptcha();
  const token = await recaptcha.execute(siteKey, { action });

  if (!token) {
    throw new Error('Google reCAPTCHA did not return a verification token.');
  }

  return token;
};

